import { render, staticRenderFns } from "./FormUnit.vue?vue&type=template&id=2db40bde&scoped=true"
import script from "./FormUnit.vue?vue&type=script&lang=js"
export * from "./FormUnit.vue?vue&type=script&lang=js"
import style0 from "./FormUnit.vue?vue&type=style&index=0&id=2db40bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db40bde",
  null
  
)

export default component.exports